"use client";

import { displayValue } from "../OtherBetsDropdown";

const formatCorrectScoresOdds = (correctScoresOdds) => {
  if (!Array.isArray(correctScoresOdds) || !correctScoresOdds.length) {
    return { home: [], draw: [], away: [] };
  }

  return correctScoresOdds.reduce(
    (acc, curr) => {
      if (Number(curr.homeScore) > Number(curr.awayScore)) {
        acc.home.push(curr);
      } else if (Number(curr.homeScore) < Number(curr.awayScore)) {
        acc.away.push(curr);
      } else {
        acc.draw.push(curr);
      }
      return acc;
    },
    { home: [], draw: [], away: [] },
  );
};

const hasAnyCorrectScoreData = (data) =>
  data &&
  (data.home?.length > 0 || data.draw?.length > 0 || data.away?.length > 0);

import { useOddsTrend } from "@/hooks/useOddsTrend";

const CorrectScoreItem = ({ item, index }) => {
  const { isUp, isDown, animating, animationClass, successValueColorClass, borderBgClass } = useOddsTrend(item.oddsTrend, item.odds);

  const title =
    item.selectionName ||
    (item.homeScore !== undefined && item.awayScore !== undefined
      ? `${item.homeScore}-${item.awayScore}`
      : "Khác");

  return (
    <div
      id={item.id ? `market_line_${item.id}` : `market_line_${index}`}
      className={`relative flex h-[38px] px-2.5 mb-1 md:min-h-[48px] md:h-auto md:pl-3.5 md:pr-4 md:mb-3 cursor-pointer items-center justify-between rounded-lg border kbv-shadow-subtle transition-colors overflow-hidden ${borderBgClass} ${animationClass} ${animating ? "" : "hover:border-[var(--theme-primary)] hover:bg-[var(--theme-accent)]"}`}
    >
      {isUp && animating && (
        <div className="absolute left-[2px] top-[2px] z-10 animate-triangle-flash kbv-triangle-up-anim" />
      )}
      {isDown && animating && (
        <div className="absolute right-[2px] bottom-[2px] z-10 animate-triangle-flash kbv-triangle-down-anim" />
      )}

      <span className={`md:text-[16px] text-[14px] kbv-text-main`}>{title}</span>

      {item.odds ? (
        <span>
          <div>
            <div className={`text-[16px] font-semibold ${successValueColorClass}`}>
              {displayValue(item.odds)}
            </div>
          </div>
        </span>
      ) : (
        <span className="text-[16px] kbv-text-main font-semibold">
          -
        </span>
      )}
    </div>
  );
};

const OkCorrectScoresOdds = ({
  correctScoresOdds,
  homeTeamName,
  awayTeamName,
}) => {
  const formatted = formatCorrectScoresOdds(correctScoresOdds);

  if (!hasAnyCorrectScoreData(formatted)) return null;

  // Determine the maximum length among home, draw, and away arrays
  const maxLength = Math.max(
    formatted.home.length,
    formatted.draw.length,
    formatted.away.length,
  );

  const flatItems = [];
  for (let i = 0; i < maxLength; i++) {
    flatItems.push(formatted.home[i] || null);
    flatItems.push(formatted.draw[i] || null);
    flatItems.push(formatted.away[i] || null);
  }

  return (
    <div>
      <div className="mb-4 flex w-full items-center text-center text-xs md:text-base kbv-text-main">
        <div className="flex-1">
          <span>{homeTeamName || "Đội nhà"}</span>
        </div>
        <span className="flex-1 text-center">Hòa</span>
        <div className="flex-1">
          <span>{awayTeamName || "Đội khách"}</span>
        </div>
      </div>

      <div className="px-0">
        <div className="grid grid-cols-3 gap-x-[15px]">
          {flatItems.map((item, index) => {
            if (!item) {
              return (
                <div
                  key={`empty-${index}`}
                  className="relative mb-[8px] h-[36px]"
                >
                  <div className="hidden"></div>
                </div>
              );
            }

            return <CorrectScoreItem key={index} item={item} index={index} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default OkCorrectScoresOdds;
